<div class="internal-notes-modal">
  <div class="modal-header">
    <h4 class="modal-title mb-0">{{ title }}</h4>
    <button type="button" class="close" aria-label="Close" id="internal_notes_close"
      (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="internal-notes-toolbar">
      <div class="queues-export-btn-group">
        <button type="button" class="icon-btn" id="internal_notes_button_export" title="Export"
          (click)="exportToExcel()">
           <img src="assets/images/neveda-images/download.svg" alt="Download" width="20" height="20" />
        </button>
      </div>
      <div class="queues-column-chooser-group">
        <button mat-icon-button class="icon-btn" id="queues_button_columnchooser_btn" title="Column Chooser"
                      (click)="toggleColumnChooser()">
                      <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none">
                        <path
                          d="M4.30775 18H8.3365V6H4.30775C4.21792 6 4.14417 6.02883 4.0865 6.0865C4.02883 6.14417 4 6.21792 4 6.30775V17.6923C4 17.7821 4.02883 17.8558 4.0865 17.9135C4.14417 17.9712 4.21792 18 4.30775 18ZM9.8365 18H14.1635V6H9.8365V18ZM15.6635 18H19.6923C19.7821 18 19.8558 17.9712 19.9135 17.9135C19.9712 17.8558 20 17.7821 20 17.6923V6.30775C20 6.21792 19.9712 6.14417 19.9135 6.0865C19.8558 6.02883 19.7821 6 19.6923 6H15.6635V18ZM4.30775 19.5C3.80258 19.5 3.375 19.325 3.025 18.975C2.675 18.625 2.5 18.1974 2.5 17.6923V6.30775C2.5 5.80258 2.675 5.375 3.025 5.025C3.375 4.675 3.80258 4.5 4.30775 4.5H19.6923C20.1974 4.5 20.625 4.675 20.975 5.025C21.325 5.375 21.5 5.80258 21.5 6.30775V17.6923C21.5 18.1974 21.325 18.625 20.975 18.975C20.625 19.325 20.1974 19.5 19.6923 19.5H4.30775Z"
                          fill="currentColor" />
                      </svg>
                    </button>
        <div *ngIf="showColumnChooser"
          class="queues-column-chooser-dialog column-chooser-dialog"
          id="internal_notes_div_columnchooser">
          <div class="queues-column-chooser-header column-chooser-header"
            id="internal_notes_div_columnheader">
            Column Chooser
            <button class="column-chooser-close" id="internal_notes_button_columnchooser_close"
              (click)="closeColumnChooser()">&times;</button>
          </div>
          <mat-selection-list #titles class="blue-checkboxes" id="internal_notes_list_columns">
            <mat-list-option *ngFor="let col of allColumns" togglePosition="before"
              [selected]="visibleColumns[col.key]" [value]="col.key"
              [id]="'internal_notes_option_' + col.key" (click)="onColumnClick(col)"
              (keypress.enter)="onColumnKey($event, col)" (keypress)="onColumnKey($event, col)"
              [disabled]="col.disabled">
              {{ col.label }}
            </mat-list-option>
          </mat-selection-list>
        </div>
      </div>
    </div>
    <div class="grid-scroll-container">
      <dx-data-grid #internalNotesGrid id="internal_notes_grid" [dataSource]="notes"
        [showBorders]="true" [width]="'100%'" [columnAutoWidth]="true" [allowColumnResizing]="true"
        [columnMinWidth]="130" [columnResizingMode]="'widget'" [rowAlternationEnabled]="true"
        [wordWrapEnabled]="true"
        class="devextreme-table table-border">
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
        <dxo-header-filter [visible]="true" [allowSearch]="true"
          [searchMode]="'contains'"></dxo-header-filter>
        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxi-column dataField="section" caption="Section" dataType="string"
          [allowHiding]="false" [allowFiltering]="true" [allowSearch]="true"
          [allowHeaderFiltering]="true" [allowSorting]="true" [minWidth]="130"
          [customizeText]="formatEmpty"
          [visible]="true"></dxi-column>
        <dxi-column dataField="notes" caption="Notes" dataType="string" [allowHiding]="true"
          [width]="'60%'" [minWidth]="180" cssClass="internal-notes-wrap-cell"
          [allowFiltering]="true" [allowSearch]="true" [allowHeaderFiltering]="true"
          [allowSorting]="true" [customizeText]="formatEmpty"
          [visible]="visibleColumns['notes']"></dxi-column>
        
        <dxi-column dataField="updated_date" caption="Updated Date" dataType="date"
          format="MM/dd/yyyy" [allowHiding]="true" [allowFiltering]="true"
          [allowHeaderFiltering]="true" [allowSorting]="true" [minWidth]="130"
          [customizeText]="formatEmpty"
          [visible]="visibleColumns['updated_date']"></dxi-column>
        <dxi-column dataField="added_by" caption="Updated By" dataType="string"
          [allowHiding]="true" [allowFiltering]="true" [allowSearch]="true"
          [allowHeaderFiltering]="true" [allowSorting]="true" [minWidth]="130"
          [customizeText]="formatEmpty"
          [visible]="visibleColumns['added_by']"></dxi-column>
        <dxo-pager [visible]="true" [allowedPageSizes]="[5, 10, 15, 25, 50]"
          [showPageSizeSelector]="true" [showNavigationButtons]="true" [showInfo]="true"
          [displayMode]="'compact'"></dxo-pager>
      </dx-data-grid>
    </div>
  </div>
</div>
